import {
  mainNavigationDashboard,
  mainNavigationSettings,
  mainNavigationQaEquipment,
  mainNavigationMedicalSystems,
  mainNavigationResultManagement,
  mainNavigationWorkManagement,
} from '@/components/icons/icons';
import { routenames } from '@/router/routenames';
import type { NavigationEntryRaw } from '../types';
import { settingsNavigationRaw } from './settingsNavigationRaw';

export const mainNavigationRaw: NavigationEntryRaw[] = [
  {
    titleI18n: 'Dashboards',
    icon: mainNavigationDashboard,
    route: { name: routenames.dashboard },
    tooltipI18n: 'Dashboards',
  },
  {
    titleI18n: 'ResultsManagement',
    icon: mainNavigationResultManagement,
    route: { name: routenames.resultManagement },
    tooltipI18n: 'ResultsManagement',
  },
  {
    titleI18n: 'WorkManagement',
    icon: mainNavigationWorkManagement,
    route: { name: routenames.workManagement },
    tooltipI18n: 'WorkManagement',
  },
  {
    titleI18n: 'MedicalSystems',
    icon: mainNavigationMedicalSystems,
    route: { name: routenames.medicalSystems.root },
    tooltipI18n: 'MedicalSystems',
  },
  {
    titleI18n: 'DosimetryAndQaEquipment',
    icon: mainNavigationQaEquipment,
    route: { name: routenames.qaEquipment.root },
    tooltipI18n: 'DosimetryAndQaEquipment',
  },
  {
    titleI18n: 'PlatformManagement',
    icon: mainNavigationSettings,
    route: { name: routenames.settings },
    children: settingsNavigationRaw,
    tooltipI18n: 'PlatformManagement',
  },
];
